import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";
import CustomAlert from "../Common/CustomAlert";

type StudentRow = (string | number | null)[];

interface SchoolCodeOption {
  value: string;
  label: string;
}

const COLUMNS = ["#", "SchoolCode", "FamilyCode", "Login", "Curriculum", "Std", "PromotedInYear", "Remarks"];

const PaginatedTable: React.FC<{
  title: string;
  rows: StudentRow[];
  timestamp: string;
}> = ({ title, rows, timestamp }) => {
  const [showNulls, setShowNulls] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredRows = showNulls
    ? rows
    : rows.filter((row) => row.some((cell) => cell !== null && cell !== ""));

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / rowsPerPage));
  const startIdx = (currentPage - 1) * rowsPerPage;
  const pageRows = filteredRows.slice(startIdx, startIdx + rowsPerPage);

  const goFirst = () => setCurrentPage(1);
  const goPrev = () => setCurrentPage((p) => Math.max(1, p - 1));
  const goNext = () => setCurrentPage((p) => Math.min(totalPages, p + 1));
  const goLast = () => setCurrentPage(totalPages);

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", border: "1px solid #aaa", overflow: "hidden" }}>
      {/* Table toolbar */}
      <div
        style={{
          padding: "3px 6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          flexWrap: "wrap",
          width: "100%",
          border: "solid 1px #80A0FF",
          borderBottom: "none",
          color: "#2859ac",
          backgroundColor: "#c7ddfd",
          fontFamily: "Arial",
          fontSize: "11pt",
          fontWeight: "bold",
        }}
      >
        <span style={{ color: "#2859B4", fontWeight: "bold", fontSize: "10pt" }}>{timestamp}</span>
        <label style={{ display: "flex", alignItems: "center", gap: "3px", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={showNulls}
            onChange={(e) => { setShowNulls(e.target.checked); setCurrentPage(1); }}
          />
          Show Nulls.
        </label>
        <span>Rows per page:</span>
        <input
          type="text"
          value={rowsPerPage}
          onChange={(e) => {
            const v = parseInt(e.target.value);
            if (!isNaN(v) && v > 0) { setRowsPerPage(v); setCurrentPage(1); }
          }}
          style={{ width: "36px", fontSize: "11px", textAlign: "center", border: "1px solid #aaa", padding: "1px 2px" }}
        />
        <span
          onClick={() => setCurrentPage(1)}
          style={{ color: "#0000cc", textDecoration: "underline", cursor: "pointer" }}
        >
          Refresh
        </span>
        <span
          onClick={goFirst}
          style={{ cursor: currentPage > 1 ? "pointer" : "default", color: currentPage > 1 ? "#333" : "#aaa" }}
        >
          &lt;&lt;
        </span>
        <span
          onClick={goPrev}
          style={{ cursor: currentPage > 1 ? "pointer" : "default", color: currentPage > 1 ? "#333" : "#aaa" }}
        >
          &lt;
        </span>
        <span>{currentPage} of {totalPages}</span>
        <span
          onClick={goNext}
          style={{ cursor: currentPage < totalPages ? "pointer" : "default", color: currentPage < totalPages ? "#0000cc" : "#aaa" }}
        >
          &gt;
        </span>
        <span
          onClick={goLast}
          style={{ cursor: currentPage < totalPages ? "pointer" : "default", color: currentPage < totalPages ? "#0000cc" : "#aaa" }}
        >
          &gt;&gt;
        </span>
      </div>

      {/* Scrollable table area */}
      <div style={{ flex: 1, overflow: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "11px",
            fontFamily: "arial",
            fontWeight: "lighter",
            color: "#2859B4",
          }}
        >
          <thead>
            <tr style={{ background: "#e8f0fb" }}>
              {COLUMNS.map((col) => (
                <th
                  key={col}
                  style={{
                    border: "1px solid #7ca4f0",
                    padding: "6px 6px",
                    textAlign: "left",
                    // fontWeight: "bold",
                    whiteSpace: "nowrap",
                    fontSize: "14px",
                    position: "sticky",
                    top: 0,
                    background: "#C7DDFD",
                    zIndex: 1,
                  }}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageRows.length === 0 ? (
              <tr>
                <td colSpan={COLUMNS.length} style={{ padding: "6px", color: "#888", textAlign: "center", fontSize: "14px" }}>
                  No data
                </td>
              </tr>
            ) : (
              pageRows.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  style={{ background: rowIndex % 2 === 0 ? "#fff" : "#f5f9ff" }}
                >
                  <td style={{ border: "1px solid #7ca4f0", padding: "2px 6px", color: "#000" }}>
                    {startIdx + rowIndex + 1}
                  </td>
                  {row.map((cell, colIndex) => (
                    <td
                      key={colIndex}
                      style={{ border: "1px solid #7ca4f0", padding: "6px 6px", whiteSpace: "nowrap", fontSize: "14px", color: "#000" }}
                    >
                      {cell === null ? "" : String(cell)}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const EL_Promote_Family_Student_Grade: React.FC = () => {
  const [country, setCountry] = useState<string>("none");
  const [schoolCode, setSchoolCode] = useState<string>("none");
  const [schoolCodes, setSchoolCodes] = useState<SchoolCodeOption[]>([]);
  const [notPromoted, setNotPromoted] = useState<StudentRow[]>([]);
  const [promotedStudents, setPromotedStudents] = useState<StudentRow[]>([]);
  const [notPromotedTimestamp, setNotPromotedTimestamp] = useState<string>("");
  const [promotedTimestamp, setPromotedTimestamp] = useState<string>("");
  const [alertInfo, setAlertInfo] = useState<{ show: boolean; message: string }>({
    show: false,
    message: '',
  });

  const API_BASE =
    process.env.REACT_APP_DOCUMENT_LINK;

  const navigate = useNavigate();

  document.body.style.backgroundColor = "azure";

  const getTimestamp = () => {
    const now = new Date();
    return now.toLocaleString("en-GB", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
      hour12: false,
      timeZone: "UTC",
    }).replace(",", "") + " UTC.";
  };

  const loadSchoolCodes = async (selectedCountry: string) => {
    setCountry(selectedCountry);
    setSchoolCode("none");
    setNotPromoted([]);
    setPromotedStudents([]);

    if (selectedCountry === "none") {
      setSchoolCodes([{ value: "none", label: "--no item--" }]);
      return;
    }

    try {
      const res = await fetch(`${API_BASE}api/get_schooldcodes_promoting_family/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          country: selectedCountry,
          // category: sessionStorage.getItem("category"),
          category: 'SCH',
        }),
      });

      const data = await res.json();

      if (Array.isArray(data) && data.length > 0) {
        const transformed: SchoolCodeOption[] = [
          { value: "none", label: "--Select--" },
          ...data.map((row: any) => ({
            value: row.schoolcode,
            label: row.schoolcode,
          })),
        ];
        setSchoolCodes(transformed);
      } else {
        setSchoolCodes([{ value: "NoItem", label: "--no items--" }]);
      }
    } catch (err) {
      console.error("Error loading school codes", err);
      setSchoolCodes([{ value: "NoItem", label: "--no items--" }]);
    }
  };

  const promoteStudents = async () => {
    if (country === "none") {
      setAlertInfo({ show: true, message: "Please select the country." });
      return;
    }
    if (schoolCode === "NoItem") {
      setAlertInfo({ show: true, message: "There is no available schoolcode for this country." });
      return;
    }
    if (schoolCode === "none") {
      setAlertInfo({ show: true, message: "Please select the SchoolCode." });
      return;
    }

    const ts = getTimestamp();

    try {
      const res = await fetch(`${API_BASE}api/promote-students/`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ country, schoolCode }),
      });

      const data = await res.json();

      const notPromotedRows: StudentRow[] = Array.isArray(data.notPromoted) ? data.notPromoted : [];
      const promotedRows: StudentRow[] =
        Array.isArray(data.promotedStudents)
          ? data.promotedStudents
          : [];

      setNotPromoted(notPromotedRows);
      setPromotedStudents(promotedRows);

      const errorLabel = data.errorMsg
        ? `( ${data.errorMsg} )`
        : `( Error While Promoting students. )`;
      const promotedLabel = data.promoted
        ? `( Promoted Students. )`
        : `( Promoted Students. )`;

      setNotPromotedTimestamp(`${ts} ${errorLabel}`);
      setPromotedTimestamp(`${ts} ${promotedLabel}`);

      if (data.promoted) {
        setAlertInfo({ show: true, message: `Total ${data.count || 0} Students have been promoted.` });
      } else if (data.errorMsg) {
        setAlertInfo({ show: true, message: data.errorMsg });
      } else if (data.warningMsg) {
        setAlertInfo({ show: true, message: data.warningMsg });
      }
    } catch (err) {
      setNotPromotedTimestamp(`${ts} ( Error While Promoting students. )`);
      setPromotedTimestamp(`${ts} ( Promoted Students. )`);
      setAlertInfo({ show: true, message: "An error occurred while promoting students." });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {alertInfo.show && (
        <CustomAlert
          message={alertInfo.message}
          onClose={() => setAlertInfo({ ...alertInfo, show: false })}
        />
      )}

      {/* HEADER */}
      <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "16px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "13pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ marginLeft: "10px" }}>Promoting Family students to next year</span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer", paddingLeft: "20px" }}
          onClick={() => navigate("/SysAdmin")}
        />
      </div>

      {/* TABLES AREA */}
      <div
        style={{
          flex: 1,
          display: (notPromoted.length > 0 || promotedStudents.length > 0) ? "flex" : "none",
          gap: "4px",
          padding: "6px",
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {/* Left: Not Promoted / Error */}
        <PaginatedTable
          title="Error"
          rows={notPromoted}
          timestamp={notPromotedTimestamp || "( Error While Promoting students. )"}
        />

        {/* Right: Promoted */}
        <PaginatedTable
          title="Promoted"
          rows={promotedStudents}
          timestamp={promotedTimestamp || "( Promoted Students. )"}
        />
      </div>

      {/* CONTROLS */}
      <div
        style={{
          flexShrink: 0,
          fontSize: "13px",
          fontFamily: "arial",
          padding: "40px 10px",
          borderTop: "1px solid #ccc",
          // background: "#f0f0f0",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <label>Country :</label>
        <select
          value={country}
          onChange={(e) => loadSchoolCodes(e.target.value)}
          style={{ fontSize: "12px" }}
        >
          <option value="none">--Select--</option>
          {[
            "Australia", "Canada", "China", "Malaysia", "International",
            "New Zealand", "Phillipines", "UAE", "UK", "USA", "Vietnam",
          ].map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <label>SchoolCode :</label>
        <select
          value={schoolCode}
          onChange={(e) => setSchoolCode(e.target.value)}
          style={{ width: "130px", fontSize: "12px" }}
        >
          {/* <option value="none">-- no item --</option> */}
          {schoolCodes.map((sc) => (
            <option key={sc.value} value={sc.value}>{sc.label}</option>
          ))}
        </select>

        <button onClick={promoteStudents} style={{ fontSize: "12px" }}>
          Promote Student
        </button>
      </div>
    </div>
  );
};

export default EL_Promote_Family_Student_Grade;